import type { PayloadStrategy } from '@/pages/components/audit/adjustment/adapters/types';
import { BankLoanWorkingPaper, VehicleLoanWorkingPaper } from '@/services/auditService/interface/loan';

// Bank Loan strategy: ensure payload conforms to BankLoanWorkingPaper
export const bankLoanStrategy: PayloadStrategy = {
  buildPayload: ({ prev, ctx, amount }) => {
    const p = (prev || {}) as Partial<BankLoanWorkingPaper> & { adjustment?: number };
    const annualId = ctx?.annualId;
    
    // Helper function to add annualId to each row
    const addAnnualId = <T extends Record<string, any>>(rows: T[]): T[] => {
      if (!Array.isArray(rows)) return rows;
      return rows.map(row => ({
        ...row,
        annualId: annualId
      }));
    };
    
    const bankLoans = addAnnualId(Array.isArray(p.bankLoans) ? p.bankLoans : []);
    
    const next: any = {};
    if (bankLoans.length > 0) next.bankLoans = bankLoans;
    // Field-level WP→WP adj (curr / nonCurr / interest) — sibling of bankLoans
    const adj = Number(p.adjustment ?? amount);
    if (Number.isFinite(adj)) next.adjustment = adj;
    
    return next;
  },
  readAmount: (payload: any) => {
    const n = Number((payload || {}).adjustment);
    return Number.isFinite(n) ? n : (undefined as any);
  },
};

// Vehicle Loan strategy: ensure payload conforms to VehicleLoanWorkingPaper
export const vehicleLoanStrategy: PayloadStrategy = {
  buildPayload: ({ prev, ctx, amount }) => {
    const p = (prev || {}) as Partial<VehicleLoanWorkingPaper> & { adjustment?: number };
    const annualId = ctx?.annualId;
    
    // Helper function to add annualId to each row
    const addAnnualId = <T extends Record<string, any>>(rows: T[]): T[] => {
      if (!Array.isArray(rows)) return rows;
      return rows.map(row => ({
        ...row,
        annualId: annualId
      }));
    };
    
    const vehicleLoans = addAnnualId(Array.isArray(p.vehicleLoans) ? p.vehicleLoans : []);
    
    const next: any = {};
    if (vehicleLoans.length > 0) next.vehicleLoans = vehicleLoans;
    const adj = Number(p.adjustment ?? amount);
    if (Number.isFinite(adj)) next.adjustment = adj;
    
    return next;
  },
  readAmount: (payload: any) => {
    const n = Number((payload || {}).adjustment);
    return Number.isFinite(n) ? n : (undefined as any);
  },
};

